// extracted by mini-css-extract-plugin
export var quillEditor = "_pm-1";
export var variable = "_pm-0";